import React from 'react';
import { Link } from 'gatsby'

function MobileMenu({ menu, active, handleClose })
{

  return (
    <div className={`fixed h-full top-0 left-0 transform transition-all duration-700 ease-in-out ${active ? "translate-x-0" : "-translate-x-full sm:-translate-x-80"}`}>
      <div className={`w-screen sm:w-80 h-full bg-blue z-50 `}>
        <div className="w-full flex-row flex justify-end ">
          <button
            type="button"
            className="right-0 p-5 rounded-md text-white hover:text-orange focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            aria-controls="mobile-menu"
            aria-expanded="false"
            onClick={handleClose}
          >
            <span className="sr-only">Close main menu</span>
            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <ul className="border-white border-b">
          {menu.map(item => (
            <li key={item.title} className="py-3 pl-5 font-bold text-lg uppercase border-t border-white">
              <Link to={"/" + item.url.slug} onClick={handleClose} className="text-white hover:text-orange">{item.title}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default MobileMenu;